import React, { useState } from "react";

function Header() {
  const [hovered, setHovered] = useState(false);

  return (
    <div className="container-fluid header-section bg-dark text-light">
      <div className="row">
        {/* First Part - Title, Explanation, and Buttons */}
        <div className="col-md-2"></div>
        <div className="col-md-5 d-flex flex-column justify-content-center align-items-start p-4">
          <h1 className="mb-3">
            Cyber Security Observatory Detection And Response And Network
            Monitoring Platforms
          </h1>
          <p className="mb-4">
            Ost Infinity ViXa Identity-First Managed Detection and Response and
            Network Monitoring, Managed Risk solution focusing on vulnerability
            assessment, Concierge Security Team (CST) extends your IT staff with
            security expertise on 24/7.
          </p>
          <div className="d-flex flex-row align-items-start">
            <button className="btn btn-primary me-2">Learn More</button>
            <button className="btn btn-warning">Log in to ViXa</button>
          </div>
        </div>
        

        {/* Second Part - Logo, Comment, and Text */}
        <div className="col-md-4 d-flex flex-column justify-content-center align-items-center p-4 text-center">
          <img
            src="logo.png"
            alt="Logo"
            className="img-fluid mb-3"
            style={{ maxWidth: "150px" }}
          />
          <p className="h5 mb-2">VIXA PLATFORMS</p>
          <p className="text-muted">AIOps | Machine Learning</p>
        </div>

        {/* Empty Space (Optional to make the layout more flexible for mobile) */}
        <div className="col-md-1"></div>
      </div>

      {/* Bottom-Center Text and User Button */}
      <div className="text-center mt-4">
        <p>Text</p>
      </div>

      <div
        className="user-button-container"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <button className="user-btn btn btn-outline-light rounded-circle">
          <i className="bi bi-person"></i> {/* Example icon */}
        </button>
        {hovered && (
          <div className="social-buttons">
            <button className="social-btn btn btn-success rounded-circle">
              <i className="bi bi-whatsapp"></i> {/* WhatsApp icon */}
            </button>
            <button className="social-btn btn btn-info rounded-circle">
              <i className="bi bi-telegram"></i> {/* Telegram icon */}
            </button>
            <button className="social-btn btn btn-danger rounded-circle">
              <i className="bi bi-envelope"></i> {/* Gmail icon */}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

export default Header;
